import React from 'react';

const FormValidationContext = React.createContext();

export default FormValidationContext;
